import { createTheme } from '@material-ui/core';
import Background from './assets/background.png';

const primary = '#6A148E';

const MainTheme = createTheme({
  palette: {
    primary: {
      main: primary,
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        body: {
          backgroundImage: `url(${Background})`,
          backgroundAttachment: 'fixed',
          backgroundRepeat: 'repeat-x repeat-y',
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderRadius: '5px 5px 0 0',
        },
      },
    },
    MuiPaper: {
      rounded: {
        borderRadius: '0 0 5px 5px',
      },
    },
    MuiListItem: {
      root: {
        '&.Mui-selected': {
          backgroundColor: primary,
          color: '#FFFFFF',
        },
        '&.Mui-selected:hover': {
          color: 'black',
        },
      },
    },
    MuiSelect: {
      root: {
        backgroundColor: 'white',
      },
    },
    MuiFormControl: {
      root: {
        marginTop: '24px',
      },
    },
    MuiTextField: {
      root: {
        backgroundColor: 'white',
        marginTop: '24px',
      },
    },
    MuiButton: {
      root: {
        height: 40,
        fontSize: 16,
      },
      outlinedSecondary: {
        '&:hover': {
          backgroundColor: '#d9d9d9',
        },
        color: '#464646',
      },
    },
  },
  typography: {
    fontFamily: [
      'Barlow',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    button: {
      textTransform: 'none',
    },
  },
});

export default MainTheme;
